export default function MachineReceipt({ receipt, refunded, onRefund }) {
  if (!receipt) return null;
  const r = receipt;

  // Compact fields — everything that was there, one flowing line, tiny font.
  // Strip the "claude-" prefix so the model name doesn't hog the row.
  const model = (r.model || "").replace(/^claude-/, "");
  const cost = `$${(r.cost_usd ?? 0).toFixed(6)}`;
  const billed = refunded ? "refunded" : `$${(r.billed_usd ?? 0).toFixed(6)}`;
  const ttft = r.ttft_ms != null ? `${r.ttft_ms}ms` : "—";
  const attach = r.attachment_count && r.attachment_count > 0
    ? ` · ${r.attachment_count}📎`
    : "";
  const wasteCredit = r.waste_flagged
    ? ` · credit -$${(r.credited_usd ?? 0).toFixed(6)}`
    : "";

  return (
    <div
      data-testid="machine-receipt"
      className="mt-3 pt-2 border-t border-dashed border-sage-border font-mono text-[10px] leading-tight text-sage-muted flex flex-wrap items-baseline gap-x-2 gap-y-0.5"
    >
      <span className="text-sage-faint uppercase tracking-[0.12em] mr-1">
        Sage receipt
      </span>
      <span className="tabular-nums">
        {model} · {r.depth} · {r.input_tokens}→{r.output_tokens} tok · ttft {ttft} · {r.duration_ms}ms · {cost}
        {wasteCredit}
        {" · billed "}
        <span className={refunded ? "text-sage-accent line-through" : ""}>{billed}</span>
        {attach}
      </span>
      {r.waste_flagged && !refunded && (
        <span className="text-sage-warn">[waste-flag: half returned]</span>
      )}
      {!refunded && onRefund && (
        <button
          onClick={onRefund}
          data-testid="refund-btn"
          className="text-sage-accent hover:underline uppercase tracking-[0.12em]"
        >
          refund ↩
        </button>
      )}
      {refunded && (
        <span className="text-sage-accent uppercase tracking-[0.12em]">
          refunded · logged
        </span>
      )}
    </div>
  );
}
